import CurrencyIcon from './icons/Currency';
import DateIcon from './icons/Date';
import Fibonacci from './icons/Fibonacci';
import Formula from './icons/Formula';
import MultiSelect from './icons/MultiSelect';
import NumberIcon from './icons/Number';
import Percent from './icons/Percent';
import Rating from './icons/Rating';
import SingleSelect from './icons/SingleSelect';
import TextIcon from './icons/Text';
import UserIcon from './icons/User';

export const CustomFieldIcon = ({
  fieldType,
  isMulti,
}: {
  fieldType?: string;
  isMulti?: boolean;
  isSystem?: boolean;
}) => {
  switch (fieldType) {
    case 'NUMBER':
      return <NumberIcon />;
    case 'DATE':
    case 'DATE_RANGE':
      return <DateIcon />;
    case 'RATING':
      return <Rating />;
    case 'CURRENCY':
      return <CurrencyIcon />;
    case 'PERCENT':
      return <Percent />;
    case 'FIBONACCI':
      return <Fibonacci />;
    case 'LIST':
      if (isMulti) {
        return <MultiSelect />;
      } else {
        return <SingleSelect />;
      }
    case 'FORMULA':
      return <Formula />;
    case 'USER':
      return <UserIcon />;
    default:
      return <TextIcon />;
  }
};
